<template>
  <div class="g-main">
    <div id="rate" class="page-rate">
      <Doctor :doctor="doctor" v-if='doctor' :type="1" :id="doctorId"></Doctor>

      <div class="rate-con border5">
        <h2>满意请给5分</h2>
        <ul class="list-rate border2">
          <li><span class="text">专业性</span><Rate v-model="rate1" color="#c0c0c0" activeColor="#ff9000"></Rate></li>
          <li><span class="text">服务态度</span><Rate v-model="rate2" color="#c0c0c0" activeColor="#ff9000"></Rate></li>
          <li><span class="text">满意度</span><Rate v-model="rate3" color="#c0c0c0" activeColor="#ff9000"></Rate></li>
        </ul>

        <div class="list-tag border2">
          <Tag ref="tag" v-for="(item, index) in tags" :index="index" :type="item.type" :key="index" shape="square" @click.native="select(index)">{{ item.txt }}</Tag>
        </div>

        <h3>给医生一些评价吧~</h3>

        <textarea class="border1" v-model="comment" name="" id="" cols="30" rows="10" placeholder="欢迎提出更多建议或意见"></textarea>
      </div>
    </div>

    <div class="bottom-bar border5">
      <Btn size="large" type="primary" @click.native="submit">提交</Btn>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import Rate from '../components/Rate';
  import Doctor from '../components/Doctor';
  import Tag from '../components/Tag';
  import Btn from '../components/Btn';

  export default {
    name: 'rate',
    data() {
      return {
        rate1: 0,
        rate2: 0,
        rate3: 0,
        tags: [
          {
            txt: '意见很有帮助',
            type: 'default'
          },
          {
            txt: '态度非常好',
            type: 'default'
          },
          {
            txt: '非常敬业',
            type: 'default'
          },
          {
            txt: '非常清楚',
            type: 'default'
          },
          {
            txt: '非常专业认真',
            type: 'default'
          },
          {
            txt: '回复很及时',
            type: 'default'
          }
        ],
        comment: '',
        label: [],
        doctorId: null
      };
    },
    components: {Rate, Doctor, Tag, Btn},
    computed: {
      // FIXME: 要做容错处理
      ...mapState([
        'doctor'
      ])
    },
    beforeCreate() {
      // 更新顶部状态
      this.$store.dispatch('updateNav', {
        title: '评价医生',
        type: 'center'
      });
    },
    created() {
      // 发埋点
      if (window.Tracking && typeof window.Tracking.initTrackUrl === 'function') {
        window.Tracking.initTrackUrl(2, 'djk_kwys_ym_pj', '');
      }

      this.doctorId = this.$route.params.doctorId;

      if (!this.doctor.name) {
        // 获取医生详情
        this.$store.dispatch('getDoctorDetail', {
          doctorid: this.doctorId
        });
      }
    },
    mounted() {},
    methods: {
      // 选择 tag
      select(index) {
        if (this.tags[index].type === 'default') {
          this.tags[index].type = 'select';
        } else {
          this.tags[index].type = 'default';
        }
      },

      // 提交评价
      submit() {
        if (this.comment.length > 500) {
          this.$dialog.Toast({mes: '字数应少于500字！'});
          return false;
        }

        if (this.rate1 === 0) {
          this.$dialog.Toast({mes: '请选择专业性评价！'});
          return false;
        }

        if (this.rate2 === 0) {
          this.$dialog.Toast({mes: '请选择服务态度评价！'});
          return false;
        }

        if (this.rate3 === 0) {
          this.$dialog.Toast({mes: '请选择满意度评价！'});
          return false;
        }

        this.$refs.tag.forEach((item) => {
          if (item.$el.className === 'tag tag-select tag-radius') {
            this.label.push(item.$el.innerText);
          }
        });

        if (this.label.length === 0) {
          this.$dialog.Toast({mes: '请选择评价标签！'});
          return false;
        }

        if (this.comment.length === 0) {
          this.$dialog.Toast({mes: '请填写评价内容！'});
          this.label = [];
          return false;
        }

        this.$store.dispatch('rate', {
          professionaldegree: this.rate1,
          informationdegree: this.rate2,
          experiencedegree: this.rate3,
          interrogationid: this.$route.params.id,
          content: this.comment,
          label: this.label.join()
        }).then((v) => {
          if (v.err) {
            this.$dialog.Toast({mes: v.err});
            return false;
          }
          this.$dialog.Toast({mes: '评价成功！'});
          setTimeout(() => {
            // 成功返回上一页
            this.$router.go(-1);
          }, 1000);

          return true;
        });
        return true;
      }
    }
  };
</script>

<style  lang="less" src="./../assets/rates.less"></style>



// WEBPACK FOOTER //
// Rates.vue?4e99ec2e